import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import { AnalyticsUtil } from "@oriola-origo/origo-common-client-lib";
import loggerMiddleware from "../logger";
import rootReducer from "../reducers";
import analyticsMiddleware from "../analytics";

const configureStore = preloadedState => {
  const middlewares = [loggerMiddleware, thunkMiddleware];

  if (AnalyticsUtil.isAnalyticsEnabled() === true) {
    middlewares.push(analyticsMiddleware);
  }

  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const composedEnhancers = composeEnhancers(...enhancers);

  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  return store;
};
export default configureStore;
